import { useEffect, useState } from "react";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import Table from "./Table";
import printerimg from "../../../../assets/print.png"
import {
  useGetVendorAddressListMutation, useGetVendorListMutation,
  usePostCreatePurchaseOrderMutation, usePostItemListMutation,
  usePostSubmitPurchaseOrderMutation, useGetAllShippingAddressesMutation,
  useGetPurchaseOrderByNameMutation,
  useUpdatePurchaseOrderMutation
} from "../../../../store/api/purchaseorderapi";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import { useGetCurrencyListQuery, useGetSelectedCompanyQuery } from '../../../../store/api/companyapi'
import { useGetPaymentTermsQuery } from "../../../../store/api/paymenttermapi";
import { useGetTermsandConditionQuery } from "../../../../store/api/termsandconditionapi";
import PrintModal from "../../../../Core/Print/PrintModal";
import BulkUpload from "./BulkUpload";
import { useGetProjectListQuery } from "../../../../store/api/projectapi";
import { useGetPriceListQuery } from "../../../../store/api/pricelistapi";
import { useGetCostCenterListQuery } from "../../../../store/api/costcenterapi";
import { useGetPurchaseTaxCategoryListQuery } from "../../../../store/api/taxcategoryapi";
import Attachment from "../../../../utils/Attachment";
import { RMcurrentGrnId } from "../../../../Localstorage/Localstorage";
import { useGetGateEntryEnableMutation } from "../../../../store/api/gateentryapi";


const PurchaseForm = () => {
  const [shipAddr, setShippaddr] = useState([]);
  const [vendor_shipp_address, setVendorshipAddress] = useState()
  const [tab, settab] = useState(1)
  const [podate, setpodate] = useState(new Date().toISOString().split('T')[0])
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error")
  const [showError, setShowError] = useState(false);
  const [finalstep, setfinalstep] = useState(false);
   const [rows, setRows] = useState([{
    item_code: "",
    item: {},
    required_by: "",
    quantity: 1,
    uom: "",
    rate: "0",
    amount: "0",
  }]);
  const [vendor_list, setvendor_list] = useState([]);
  const [paymentterm, setpaymentterm] = useState([]);
  const [termsandcondition, settermsandcondition] = useState([]);
  const [po_response, setpo_response] = useState("");
  const [select_vendor, setselect_vendor] = useState("");
  const [required_date, setrequired_date] = useState("");
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [showpopup, setShowpopup] = useState(false);
  const [podetailWithApi, setpodetailWithApi] = useState(null);
  const [selected_item_data, setselected_item_data] = useState([]);
  const [select_vendor_address, setselect_vendor_address] = useState({});
  const [taxandchanges, settaxandchanges] = useState('');
  const [cost_center, setcost_center] = useState('');
  const [project, setproject] = useState('');
  const [currency, setcurrency] = useState('INR');
  const [pricel, setpricel] = useState('Standard Buying');
  const [asn_inclusion, setasn_inclusion] = useState(false);
  const [vendor_address_list, setvendor_address_list] = useState([]);
  const [fieldErrors, setFieldErrors] = useState({
    vendor: false,
    vendor_address: false,
    required_date: false,
    items: false
  });
  const [getAllShippingAddresses, { data: addressData, isLoading }] = useGetAllShippingAddressesMutation();
  const [getPurchaseOrderByName] = useGetPurchaseOrderByNameMutation();
  const [getvendor_list] = useGetVendorListMutation();
  const [getitem_list_data] = usePostItemListMutation();
  const [Create_Purchase] = usePostCreatePurchaseOrderMutation();
  const [updatePurchaseOrder] = useUpdatePurchaseOrderMutation()
  const [Submit_Purchase] = usePostSubmitPurchaseOrderMutation();
  const [getvendor_address_list_data] = useGetVendorAddressListMutation();
  const [activityboll, setactivityboll] = useState(false)
  const [isGateEntryChecked, setIsGateEntryChecked] = useState(false)

  const getVendorAndWarehouse = async () => {
    const venderApiData = await getvendor_list()
    setvendor_list(venderApiData.data.result);
  }
  const { data } = useGetSelectedCompanyQuery();
  const selectedComapny = data?.message?.data?.company;
  const { data:p_term } = useGetPaymentTermsQuery();
  const { data:tandc } = useGetTermsandConditionQuery();
  const { data:taxandchangeslist } = useGetPurchaseTaxCategoryListQuery(selectedComapny);
   const filters = [
    ["company", "=", selectedComapny?.split(" - ")[0]],
    ["disabled", "=", 0],
    ["is_group", "=", 0]
  ];
  const { data:costcenterlist } = useGetCostCenterListQuery({filters: JSON.stringify(filters)});
  const { data:projectlist } = useGetProjectListQuery({filter:{"company":selectedComapny}});
  const { data:currencylist } = useGetCurrencyListQuery();
  const { data: pricelist } = useGetPriceListQuery({ filters: JSON.stringify({ buying: 1 }) });
  const [isGateEntryEnabled] = useGetGateEntryEnableMutation();



  const getVendor_Address = async () => {
    try {
      const vendorAddressApiData = await getvendor_address_list_data({ vendor: select_vendor })
      setvendor_address_list(vendorAddressApiData?.data?.result);
      setselect_vendor_address(vendorAddressApiData?.data?.result?.[0])
    } catch (error) {
      console.log("check error", error)
    }
  }

  const CreatePurchaseOrder = async () => {

    setFieldErrors({
      vendor: false,
      vendor_address: false,
      required_date: false,
      items: false
    });

    let hasError = false;
    const newErrors = {
      vendor: !select_vendor,
      vendor_address: !(select_vendor_address?.name),
      required_date: !required_date,
      items: selected_item_data.length === 0
    };

    const FirsthasInvalidItem = selected_item_data.some(item => !item.item_code || !item.quantity);
    if (FirsthasInvalidItem) {
      newErrors.items = true;
    }
    setFieldErrors(newErrors);
    hasError = Object.values(newErrors).some(error => error);

    if (hasError) {
      setptype("Error");
      setError(FirsthasInvalidItem
        ? 'Please make sure all selected items have Item Code, Required By, Quantity, and Rate.'
        : 'Please fill all required fields before creating the purchase order.');
      setShowError(true);
      return;
    }

    if (!required_date || !select_vendor || !select_vendor_address || selected_item_data.length === 0) {
      setptype("Error")
      setError('Please fill all required fields before creating the purchase order.');
      setShowError(true);
      return;
    }
    const hasInvalidItem = selected_item_data.some(item => !item.item_code || !item.quantity);
    if (hasInvalidItem) {
      setptype("Error")
      setError('Please make sure all selected items have Item Code,Required By, Quantity, and Rate.');
      setShowError(true);
      return;
    }
    const filter_Item_Data = selected_item_data.map(item => ({
      item_code: item.item.item_code,
      quantity: item.quantity,
      rate: item.rate
    }));
	console.log("kdkdkd",filter_Item_Data);


    const SenderData = {
      "schedule_date": required_date,
      "vendor": select_vendor,
      "vendor_address": select_vendor_address.name,
      "items": filter_Item_Data,
      "shipping_address": vendor_shipp_address ? vendor_shipp_address.name : "",
      "currency": currency,
      "price_list": pricel,
      "cost_center": cost_center,
      "project": project,
      "tax_category": taxandchanges,
      "payment_terms_template": paymentterm,
      "terms_and_conditions": termsandcondition,
     "asn_inclusion": asn_inclusion ? 1 : 0
    }

    try {
      console.log("check send dat4a nn is here",SenderData);
      const ResponseData = await Create_Purchase(SenderData)
      if (ResponseData.error) {
        setptype("Error")
        setError(ResponseData.error?.data?.message);
        setShowError(true);
        return;
      }

      setpo_response(ResponseData.data)
      console.log("Res Save",ResponseData.data)
      console.log("Po Res", po_response);
      const newPO = await getPurchaseOrderByName({ doctype: 'Purchase Order', name: ResponseData.data.data });
      setpodetailWithApi(newPO.data);
      setptype("Message")
      setError("Purchase Order Saved Successfully");
      setShowError(true);

      setTimeout(() => {
        setptype("Error")
        setError("");
        setShowError(false);
      }, 4000);

    } catch (err) {
      console.log("check err", err)

       const apiErrors = [];

    if (err?.data?.message) {
        apiErrors.push(err?.data?.message); 
    } else if (err?.message) {
        apiErrors.push(err?.message);
    } else {
        apiErrors.push("Something went wrong while saving the order.");
    }

    setError(apiErrors);        
    setptype("Error");         
    setShowError(true);
    }
  }

  const UpdatePO = async () => {


    const filter_Item_Data = selected_item_data.map(item => ({
      item_code: item.item.item_code,
      quantity: item.quantity,
      rate: item.rate
    }));
        const payload = {
            purchase_order_id: po_response.data,
            schedule_date: required_date,
            vendor: select_vendor,
            "shipping_address": vendor_shipp_address ? vendor_shipp_address.name : "",
            "vendor_address": select_vendor_address.name,
            items: filter_Item_Data,
            "currency": currency,
            "price_list": pricel,
            "cost_center": cost_center,
            "project": project,
            "tax_category": taxandchanges,
            "payment_terms_template": paymentterm,
            "terms_and_conditions": termsandcondition,
              "asn_inclusion": asn_inclusion ? 1 : 0

        };

        try {
            const response = await updatePurchaseOrder(payload).unwrap();
            setpo_response(response);
            const newPO = await getPurchaseOrderByName({ doctype: 'Purchase Order', name: po_response.data });
            setpodetailWithApi(newPO.data);
            setptype("Message")
            setError("Purchase updated Successfully");
            setTimeout(() => {
                // navigate('/inbound/purchaseorder/purchase-orders')
                setShowError(true);
            }, 2000);
        } catch (err) {
            const apiErrors = [];
            if (err?.data?.message) {
                const serverMessages = JSON.parse(err?.data?._server_messages);
                if (serverMessages.length > 0) {
                    const firstMessage = JSON.parse(serverMessages[0]);
                    apiErrors.push(firstMessage.message);
                }
            } else if (err?.message) {
                apiErrors.push(err?.message);
                const serverMessages = JSON.parse(err?._server_messages);
                if (serverMessages.length > 0) {
                    const firstMessage = JSON.parse(serverMessages[0]);
                    apiErrors.push(firstMessage.message);
                }
            } else {
                apiErrors.push("Something went wrong while saving the order.");
            }

            setError(apiErrors);
            setptype("Error");
            setShowError(true);
        }
  };

  const SubmitPurchaseOrder = async () => {
    try {
      const ResponseData = await Submit_Purchase({ "purchase_order_name": po_response.data })
      const res = await isGateEntryEnabled({ "po_name": po_response.data });
      setptype("Message")
      setError("Purchase Order Sumbit Successfully");
      setShowError(true);
      setfinalstep(true)
      setIsGateEntryChecked(res.data.message)
      setactivityboll(true);
      setTimeout(() => {

        setptype("")
        setError("");
        setShowError(false);
      }, 4000);

    } catch (error) {

    }
  }




    useEffect(() => {
    if (data?.message?.data?.company) {
      const rawCompanyName = data.message.data.company;
      const companyName = rawCompanyName.split(' - ')[0];

      getAllShippingAddresses({ company_name: companyName });
    }
  }, [data, getAllShippingAddresses]);

  useEffect(() => {
    if (addressData?.message) {
      if(addressData.message == "Addresses fetched successfully"){
        const names = addressData?.message.map((item) => ({ name: item.name }));
        setShippaddr(names);
      }
    }
  }, [addressData]);

  useEffect(() => {
    getVendor_Address()
  }, [select_vendor])

  useEffect(() => {
    getVendorAndWarehouse()
  }, [])

  useState(() => {
    console.log("Res Save",po_response);
  },[po_response])


  return (
		<FormLayout
			title="New Purchase Order"
			breadcrumbs={[
				{ label: "Inbound" },
				{
					label: "Purchase Order List",
					url: "/inbound/purchaseorder/purchase-orders",
				},
			]}
			status={po_response?.data ? "Draft" : "New"}
			finalStep={finalstep}
			actionButtons={
				<>
					{isGateEntryChecked === false ? (
						<Button
							onClick={() => {
								RMcurrentGrnId();
							}}
							to="/inbound/grn/create-purchase-receipt"
							state={po_response?.data}
							style={{ backgroundColor: "#fff", height: "28px" }}
							className="custom-btn-00989blue"
							display={finalstep ? "flex" : "none"}
						>
							+ Create GRN
						</Button>
					) : (
						<Button
							onClick={() => {
								RMcurrentGrnId();
							}}
							to="/inbound/gate-entry/create-gate-entry"
							state={po_response?.data}
							style={{ backgroundColor: "#fff", height: "28px" }}
							className="custom-btn-00989blue"
							display={finalstep ? "flex" : "none"}
						>
							+ Create Gate Entry
						</Button>
					)}

					{!finalstep && (
						<Button
							className="custom-btn-bluecolor d-flex"
							iconName="BiCloudUpload"
							style={{ gap: "2px" }}
							iconSize={14}
							onClick={() => {
								setShowpopup(true);
							}}
						>
							Upload
						</Button>
					)}

					{po_response.data && (
						<Button
							className="custom-btn-00989"
							onClick={UpdatePO}
							iconName="LuFilePlus2"
							style={{ gap: "2px", height: "28px" }}
							iconSize={12}
							display={finalstep ? "none" : "flex"}
						>
							Update
						</Button>
					)}

					<Button
						className="custom-btn-00989"
						onClick={
							po_response.data ? SubmitPurchaseOrder : CreatePurchaseOrder
						}
						iconName="LuFilePlus2"
						style={{ gap: "2px", height: "28px" }}
						iconSize={12}
						display={finalstep ? "none" : "flex"}
					>
						{po_response.data ? "Submit" : "Save"}
					</Button>

					{po_response && (
						<p className="p-0 m-0">
							<img
								src={printerimg}
								onClick={() => setShowPrintModal(true)}
								className="px-2"
								style={{ width: "35px", cursor: "pointer" }}
								alt="404"
							/>
						</p>
					)}
				</>
			}
		>
			<div
				className="d-flex flex-column"
				style={{ width: "100%", backgroundColor: "#fff", flexGrow: "1" }}
			>
				<div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
					<div className="d-flex justify-content-between align-items-end ">
						<ul
							className="nav nav-tabs"
							style={{ color: "white", border: "none" }}
						>
							<li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
								<a
									className={
										tab == 1
											? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
											: "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
									}
									onClick={() => {
										settab(1);
									}}
									href="javascript:void(0);"
								>
									General Details
									{tab == 1 ? (
										<GetIcon iconName="MdKeyboardArrowDown" size={15} />
									) : (
										<GetIcon iconName="MdKeyboardArrowRight" size={15} />
									)}
								</a>
							</li>
							<li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner">
								<a
									className={
										tab == 2
											? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
											: "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
									}
									onClick={() => {
										settab(2);
									}}
									href="javascript:void(0);"
								>
									Address & Contact{" "}
									{tab == 2 ? (
										<GetIcon iconName="MdKeyboardArrowDown" size={15} />
									) : (
										<GetIcon iconName="MdKeyboardArrowRight" size={15} />
									)}
								</a>
							</li>
						</ul>
						{po_response.data && (
							<Attachment doctype="Purchase Order" docname={po_response.data} />
						)}
					</div>
				</div>

				<div
					className="row d-flex justify-content-between "
					style={{ marginTop: "14px", flexGrow: "1" }}
				>
					{tab == 1 ? (
						<div
							className="col-3 "
							style={{
								visibility: tab == 1 ? "visible" : "hidden",
								height: tab == 1 ? "auto" : "0px",
							}}
						>
							<Tab1
								activityboll={activityboll}
								pTerms={{
									paymentterm: paymentterm,
									setpaymentterm: setpaymentterm,
									list: p_term?.data,
								}}
								termandcondition={{
									termsandcondition,
									settermsandcondition,
									list: tandc?.data,
								}}
								vendor={{
									vendor_list: vendor_list,
									setselect_vendor: setselect_vendor,
									select_vendor: select_vendor,
									Error: fieldErrors.vendor,
								}}
								selectedAddress={{
									list: vendor_address_list,
									currentAddress: select_vendor_address,
									Error: fieldErrors.vendor_address,
								}}
								required_date={{
									setrequired_date: setrequired_date,
									required_date: required_date,
									Error: fieldErrors.required_date,
								}}
								podate={{ podate: podate, setpodate: setpodate }}
								ponumber={finalstep}
								realponumber={po_response?.data}
								taxandchanges={{
									list: taxandchangeslist?.data,
									setvalue: settaxandchanges,
									value: taxandchanges,
								}}
								cost_center={{
									list: costcenterlist?.data,
									setvalue: setcost_center,
									value: cost_center,
								}}
								project={{
									list: projectlist?.data,
									setvalue: setproject,
									value: project,
								}}
								currency={{
									list: currencylist?.data,
									setvalue: setcurrency,
									value: currency,
								}}
								price={{
									list: pricelist?.data,
									setvalue: setpricel,
									value: pricel,
								}}
								setasn_inclusion={setasn_inclusion}
								asn_inclusion={asn_inclusion}
							/>
						</div>
					) : (
						""
					)}
					{tab == 1 ? (
						<div
							className="col-9 d-flex flex-column mt-2"
							style={{
								visibility: tab == 1 ? "visible" : "hidden",
								height: tab == 1 ? "auto" : "0px",
								minHeight: tab == 1 ? "440px" : "0",
							}}
						>
							<div className="d-flex pb-2" style={{ gap: "5px" }}>
								<p className="NoOfLine">
									No. of lines -{" "}
									<span style={{ color: "#2563EB" }}>
										{" "}
										{selected_item_data.length}
									</span>
								</p>
								<p className="TotalQty">
									Total Quantity -{" "}
									<span style={{ color: "#16A34A" }}>
										{" "}
										{selected_item_data.reduce((total, item) => {
											return total + Number(item.quantity);
										}, 0)}
									</span>
								</p>
								<p
									className="ReceivedQty"
									style={{ display: po_response.data ? "" : "none" }}
								>
									Received Quantity -{" "}
									<span style={{ color: "#EC642A" }}>
										{" "}
										{selected_item_data.reduce(
											(sum, item) => sum + Number(item.quantity),
											0
										)}
									</span>
								</p>
							</div>
							<div className="tableLabel">
								<div
									style={{
										width: "98.5%",
										borderBottom: "1px solid #caced3",
										marginBottom: "6px",
									}}
								></div>
								<p
									className=""
									style={{
										color: "#1E1E1E",
										fontWeight: "500",
										fontSize: "15px",
										marginBottom: "4px",
									}}
								>
									Item Details
								</p>
							</div>
							<Table
								setselected_item_data={setselected_item_data}
								rows={rows}
								setRows={setRows}
								list_data={getitem_list_data}
								po_status={finalstep == false ? "" : "submited"}
							/>
							<div
								className=" mt-auto pb-1"
								style={{ display: po_response.data ? "" : "none" }}
							>
								<div className="row">
									<div
										className="row"
										style={{ display: "flex", flexWrap: "wrap" }}
									>
										<div style={{ width: "20%" }}>
											<p className="TotalQtywithoutBg">
												Ordered Quantity -
												<span style={{ color: "#EC642A" }}>
													{selected_item_data.reduce(
														(sum, item) => sum + Number(item.quantity),
														0
													)}
												</span>
											</p>
										</div>

										<div style={{ width: "18%" }}>
											<p className="NoOfLinewithoutBg">
												Total Value -
												<span style={{ color: "#FF5969" }}>
													{selected_item_data.reduce(
														(sum, item) =>
															sum +
															Number(item.quantity) * Number(item.item.buying_price),
														0
													)}
												</span>
											</p>
										</div>

										<div style={{ width: "24%" }}>
											<p className="NoOfLinewithoutBg">
												Tax Type -
												<span style={{ color: "#C40AB8" }}>
													{podetailWithApi?.message?.taxes.length == 0
														? ""
														: podetailWithApi?.message?.taxes
																.reduce((acc, curr) => {
																	if (!acc.includes(curr.description)) {
																		acc.push(curr.description);
																	}
																	return acc;
																}, [])
																.join(", ")}
												</span>
											</p>
										</div>

										<div style={{ width: "15%" }}>
											<p className="NoOfLinewithoutBg">
												Tax -
												<span style={{ color: "#2563EB" }}>
													{podetailWithApi?.message?.total_taxes_and_charges}
												</span>
											</p>
										</div>

										<div style={{ width: "22%" }}>
											<p className="NoOfLinewithoutBg">
												Grand Total -
												<span style={{ color: "#16A34A" }}>
													{/* {selected_item_data.reduce((sum, item) => sum + Number(item.quantity * item.item.buying_price), 0)} */}
													{podetailWithApi?.message?.grand_total}
												</span>
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					) : (
						""
					)}

					<div
						className="col-12"
						style={{
							visibility: tab == 2 ? "visible" : "hidden",
							height: tab == 2 ? "auto" : "0px",
							overflow: tab == 2 ? "" : "hidden",
						}}
					>
						<Tab2
							read={finalstep}
							// read={po_response?.data}
							status={finalstep ? "Draft" : "New"}
							vendor_address={{
								vendor_address_list: vendor_address_list,
								setselect_vendor_address: setselect_vendor_address,
								currentAddress: select_vendor_address,
							}}
							shippingAddr={{
								setVendorshipAddress: setVendorshipAddress,
								shippingAddresseslist: shipAddr,
								currentAddress: vendor_shipp_address,
							}}
						/>
					</div>
				</div>
			</div>

			{showPrintModal && (
				<PrintModal
					onClose={() => setShowPrintModal(false)}
					documentId={po_response?.data}
					doctype="Purchase Order"
					title="Print Purchase Order"
				/>
			)}
			<ApiResponseBox
				poptype={ptype}
				show={showError}
				errorMessage={error}
				onClose={() => setShowError(false)}
			/>

			<BulkUpload
				show={showpopup}
				onClose={() => setShowpopup(false)}
				rows={rows}
				setRows={setRows}
				setselected_item_data={setselected_item_data}
			/>
		</FormLayout>
	);
};

export default PurchaseForm;